import { render, staticRenderFns } from "./PageSettingsGeneral.vue?vue&type=template&id=35842194&"
import script from "./PageSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./PageSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports